@if (initialized) {
    <div class="grid">
        <!-- Model Drafts List -->
        <div class="col-12 lg:col-4">
            <div class="card">
                <mvs-widget
                        *ngIf="modelDraftsWidget"
                        [widgetData]="modelDraftsWidget"
                        (onObjectSelect)="handleModelDraftSelect($event)"
                ></mvs-widget>
            </div>
        </div>

        @if (selectedModelDraft) {
            <!-- Model Draft Info -->
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="flex align-items-center justify-content-between mb-3">
                        <h5 class="m-0">{{ selectedModelDraft.name }}</h5>
                        <span class="p-tag"
                              [class.p-tag-warning]="selectedModelDraft.status === 0"
                              [class.p-tag-success]="selectedModelDraft.status === 1"
                              [class.p-tag-info]="selectedModelDraft.status === 2">
                            @switch (selectedModelDraft.status) {
                                @case (0) { Draft }
                                @case (1) { Approved }
                                @case (2) { Exported }
                            }
                        </span>
                    </div>
                    @if (selectedModelDraft.description) {
                        <p class="text-600">{{ selectedModelDraft.description }}</p>
                    }
                    <div class="flex gap-4 text-sm text-600">
                        @if (selectedModelDraft.namespace) {
                            <span><i class="fa-regular fa-code mr-1"></i>{{ selectedModelDraft.namespace }}</span>
                        }
                        @if (selectedModelDraft.alias) {
                            <span><i class="fa-regular fa-tag mr-1"></i>{{ selectedModelDraft.alias }}</span>
                        }
                    </div>
                </div>
            </div>

            <!-- Field List -->
            <div class="col-12 lg:col-6">
                <div class="card">
                    <h5 class="mb-3">Model Fields</h5>
                    <ea-model-draft-field-list-widget
                            [modelDraftId]="selectedModelDraft.id"
                            (onFieldSelect)="handleFieldSelect($event)"
                    ></ea-model-draft-field-list-widget>
                </div>
            </div>

            <!-- Field Editor -->
            <div class="col-12 lg:col-6">
                <div class="card">
                    <h5 class="mb-3">Field Editor</h5>
                    @if (selectedFieldId) {
                        <ea-model-draft-field-editor-widget
                                [fieldId]="selectedFieldId"
                                (onFieldSaved)="handleFieldSaved()"
                        ></ea-model-draft-field-editor-widget>
                    } @else {
                        <div class="flex flex-column align-items-center justify-content-center p-6 text-center surface-100 border-round">
                            <i class="fa-regular fa-edit text-4xl text-400 mb-3"></i>
                            <span class="text-600">Select a field to edit its properties</span>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="col-12 lg:col-8">
                <div class="card">
                    <div class="flex flex-column align-items-center justify-content-center p-6 text-center surface-100 border-round">
                        <i class="fa-regular fa-sitemap text-4xl text-400 mb-3"></i>
                        <span class="text-600">Select a model draft to view details</span>
                    </div>
                </div>
            </div>
        }
    </div>
}
